import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Stack,
  Typography,
  Link,
} from '@mui/material';
import { useGetFilePlayerFilesQuery } from 'app/api/assetApi';
import { useFileListState } from '../hooks/useFileListState';
import { FileListLayout } from './FileListLayout';
import { FileGridLayout } from './FileGridLayout';
import { FileMasterCheckbox } from './FileMasterCheckBox';
import { FileToggleViewButton } from './FileToggleViewButton';
import { useFilePlayerContext } from '../FilePlayerContext';
import { FileActionBar } from './FileActionBar';
import {
  LoadingState,
  ErrorState,
  EmptyState,
  LoadMoreButton,
} from './FilePanelHelpers';

// TODO: consider refactoring with FilesTab
export const FileGroupFilesPanel = ({ filters, advisorLogin }) => {
  const { playItems, deletedFileIds } = useFilePlayerContext();
  const [page, setPage] = useState(1);
  const { data, error, isLoading, isError } = useGetFilePlayerFilesQuery({ page, filters });
  const files = data?.pages?.flatMap((p) => p.items) || [];
  const hasMore = !!data?.pages.at(-1)?.nextPage;
  const fileListState = useFileListState(files, deletedFileIds);
  const { visibleFiles, listView, setListView } = fileListState;
  const showMasterCheckbox = visibleFiles.length > 0;

  const handlePlayAll = () => {
    if (visibleFiles.length > 0) playItems(visibleFiles);
  };

  if (isLoading && page === 1) return <LoadingState />;
  if (isError) return <ErrorState error={error} />;
  if (!visibleFiles.length && !hasMore) return <EmptyState message="No files match this group." />;

  return (
    <Stack spacing={2} mt={2}>
      <FileActionBar fileListState={fileListState} />
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" spacing={1} alignItems="center">
          {showMasterCheckbox && (
            <>
              <FileMasterCheckbox fileListState={fileListState} />
              <Typography variant="body1" fontWeight="medium">
                All
              </Typography>
            </>
          )}
        </Stack>

        <Stack direction="row" spacing={2} alignItems="center">
          {advisorLogin && (
            <Link
              href={`/${advisorLogin}`}
              variant="body2"
              underline="hover"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit Storefront
            </Link>
          )}
          <Link
            component="button"
            variant="body2"
            onClick={handlePlayAll}
            underline="hover"
          >
            Play All
          </Link>
          <FileToggleViewButton listView={listView} setListView={setListView} />
        </Stack>
      </Stack>

      {listView ? (
        <FileListLayout fileListState={fileListState} />
      ) : (
        <FileGridLayout fileListState={fileListState} drawer />
      )}

      {hasMore && <LoadMoreButton setPage={setPage} isLoading={isLoading} />}
    </Stack>
  );
};

FileGroupFilesPanel.propTypes = {
  filters: PropTypes.shape({
    advisor_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    date: PropTypes.string,
  }).isRequired,
  advisorLogin: PropTypes.string,
};

FileGroupFilesPanel.defaultProps = {
  advisorLogin: null,
};
